import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import { useHasMarketingDataAccess } from '@/utils/hooks';


const LeadMarketingCampaign = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const customer = lead?.customer || null
  const hasMarketingDataAccess = useHasMarketingDataAccess()

  if (!hasMarketingDataAccess) return null;

  const content = customer?.utm_campaign || null
  if (isTable) return <div style={{minWidth: 130}}>{content}</div>
  return content
}

export default LeadMarketingCampaign
